import { render, staticRenderFns } from "./SchoolClassDemo.vue?vue&type=template&id=5b0285a3"
import script from "./SchoolClassDemo.vue?vue&type=script&lang=js"
export * from "./SchoolClassDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports